import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Section, SectionHeader } from './ui/Section';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const active = testimonials[index];
  const go = (direction: -1 | 1) => {
    setIndex(prev => (prev + direction + testimonials.length) % testimonials.length);
  };
  return <Section className="py-14 sm:py-16 lg:py-20" data-id="element-150" data-mp="370k8qbt7clk8">
      <SectionHeader title="Personas que también decidieron organizar Europa por su cuenta" data-id="element-151" data-mp="3205ziqfv75km" />

      <div className="mt-9 flex items-center gap-2 sm:mt-12 sm:gap-4" data-id="element-152" data-mp="2x0jn2j7v1tcv">
        <NavButton label="Ver testimonio anterior" onClick={() => go(-1)} data-id="element-153" data-mp="2x2w50wdmc3px">
          <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="2s39p2f6eo9df" />
        </NavButton>

        <figure className="flex min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-oceano/10 bg-white sm:flex-row" data-id="element-155" data-mp="v8591v8ft91q">
          <img src={active.photo} alt={`${active.name} durante su viaje por Europa`} className="h-52 w-full object-cover sm:h-auto sm:w-[38%] sm:self-stretch" data-id="element-156" data-mp="q891xn4g11hy" />
          <div className="flex flex-1 flex-col justify-center p-5 sm:p-8" data-id="element-157" data-mp="m62n7z61vxr7">
            <blockquote className="font-sans text-[13px] leading-relaxed text-oceano/85 sm:text-[14px]" data-id="element-158" data-mp="78ab7gzpprhr">
              “{active.quote}”
            </blockquote>
            <figcaption className="mt-5" data-id="element-159" data-mp="c8y1u1k146bg">
              <span className="block font-display text-[20px] font-bold leading-none text-oceano" data-id="element-160" data-mp="zvwhix0bra8b">
                {active.name}
              </span>
              <span className="mt-1.5 block font-sans text-[10.5px] uppercase tracking-[0.14em] text-travertino" data-id="element-161" data-mp="14xlre9bt9hut">
                {active.trip}
              </span>
            </figcaption>
          </div>
        </figure>

        <NavButton label="Ver testimonio siguiente" onClick={() => go(1)} data-id="element-162" data-mp="1ivabvg1yumzc">
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="1itz5r9l1t352" />
        </NavButton>
      </div>

      <div className="mt-6 flex items-center justify-center gap-2" data-id="element-164" data-mp="1no3he659dzch">
        {testimonials.map((testimonial, dotIndex) => <button key={testimonial.name} type="button" aria-label={`Ver testimonio de ${testimonial.name}`} aria-current={dotIndex === index} onClick={() => setIndex(dotIndex)} className={`h-[3px] rounded-full transition-[width,background-color] duration-200 ease-out ${dotIndex === index ? 'w-7 bg-caribe' : 'w-3 bg-oceano/15'}`} data-id="element-165" data-mp="1xfmtt5udgrt7" data-mpi={dotIndex} />)}
      </div>
    </Section>;
}
function NavButton({
  children,
  label,
  onClick
}: {
  children: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return <button type="button" aria-label={label} onClick={onClick} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-oceano/15 text-oceano transition-colors duration-150 ease-out hover:border-caribe hover:text-caribe sm:h-10 sm:w-10" data-id="element-166" data-mp="19qli99q8t0jp">
      {children}
    </button>;
}